import { getAppUrl } from 'platform/utilities/registry-helpers';

// declare global app URLs for use with content links
export const APP_URLS = {
  '1010d': getAppUrl('10-10d-extended'),
  askVa: getAppUrl('ask-va'),
  ohi: getAppUrl('10-7959C'),
};
